// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"eb570f4f","492":"c15f17cd","579":"e6c73351"}[chunkId] + ".chunk.js";
};